import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';

export default function PersonTab({ setIdentifierToConsent, setVigency }) {
  const [consentExpiration, setConsentExpiration] = useState('1 mês');
  const consentExpirationOptions = [
    { display: '1 dia', value: 1 },
    { display: '1 semana', value: 7 },
    { display: '1 mês', value: 30 },
    { display: ' 1 ano', value: 365 },
    { display: 'Até revogação manual', value: null }];
  const [isListOpen, setIsListOpen] = useState(false);
  return (
    <div className="newConsentModal-inputCpf br-input">
      <p>
        Informe o CPF da pessoa com quem você deseja compartilhar suas informações de saúde:
      </p>
      <input onChange={(e) => e.target.value.length === 11 && setIdentifierToConsent(e.target.value)} type="text" placeholder="Digite o CPF" />
      <div className="selectExpiration">
        <div className="br-select">
          <div className="br-input">
            <p>Informe por quanto tempo você deseja compartilhar seu RES</p>
            <input
              id="select-simple"
              type="text"
              value={consentExpiration}
              placeholder="Selecione o item"
              onClick={() => setIsListOpen(!isListOpen)}
            />
            <button onClick={() => setIsListOpen(!isListOpen)} className="br-button" type="button" aria-label="Exibir lista">
              {!isListOpen
                ? <FaCaretDown />
                : <FaCaretUp />}
            </button>
          </div>
          {isListOpen
            ? (
              <div className="newConsentModal br-list" style={{ display: 'block' }}>
                {
                  consentExpirationOptions
              && (
                <>
                  { consentExpirationOptions.map((option, index) => (
                    <div className="br-item" key={index}>
                      <div className="br-radio">
                        <input
                          onClick={() => {
                            setIsListOpen(!isListOpen);
                            setConsentExpiration(option.display);
                            setVigency(option.value);
                          }}
                          id={`rb${index}`}
                          type="radio" name="consentExpirationOptions"
                          value={option}
                        />
                        <label htmlFor={`rb${index}`}>
                          {option.display}
                        </label>
                      </div>
                    </div>

                  ))}
                </>
              )
                }
              </div>
            )
            : <></>}

        </div>
      </div>
    </div>

  );
}

PersonTab.propTypes = {
  setIdentifierToConsent: PropTypes.element.isRequired,
  setVigency: PropTypes.element.isRequired,
};
